import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import Investment from 'src/entities/Investment';
import { ApiProjectResponse } from 'src/services/entity-factory/factories/ProjectFactory';
import { ApiPersonResponse } from 'src/services/entity-factory/factories/PersonFactory';
import { Moment } from 'moment';
import * as moment from 'moment';

export interface ApiInvestmentResponse {
  id: number;
  project: ApiProjectResponse;
  person: ApiPersonResponse;
  quantityTickets: number;
  tcaRepresentative: boolean;
  acceptsCommitment: boolean;
  termsAndConditions: boolean;
  status: string;
  acceptedShareholderAgreement: boolean;
  acceptedSyndicateAgreement: boolean;
  signedShareholderAgreement: boolean;
  signedSyndicateAgreement: boolean;
  fees: number;
  amountInvested: number;
  actualPrice: number;
  createdAt?: Moment;
  dueDiligenceStatus?: string;
  isPaid: boolean;
  essentialAsset?: boolean;
}

export interface ApiInvestmentRequest {
  personId: number;
  projectId: number;
  quantityTickets: number;
  tcaRepresentative: boolean;
  acceptsCommitment: boolean;
  termsAndConditions?: boolean;
  personType: string;
  status?: string;
  acceptedShareholderAgreement?: boolean;
  acceptedSyndicateAgreement?: boolean;
  signedShareholderAgreement?: boolean;
  signedSyndicateAgreement?: boolean;
  createdAt?: Moment;
  dueDiligenceStatus?: string;
  essentialAsset?: boolean;
}

export class InvestmentFactory extends BaseFactory<Investment> {
  public toEntity(args: ApiInvestmentResponse): Investment {
    return new Investment({
      ...args,
      createdAt: moment(args.createdAt) || undefined,
      project: args.project ?
        this.entityFactoryFactory.projectFactory.toEntity(args.project) :
        undefined,
      person: args.person ?
        this.entityFactoryFactory.personFactory.toEntity(args.person) :
        undefined,
      dueDiligenceStatus: args.dueDiligenceStatus || '',
      essentialAsset: args.essentialAsset || undefined
    });
  }

  public toRequest(investment: Investment): ApiInvestmentRequest {
    if (!investment.project || !investment.person) {
      throw new Error('invalid data');
    }

    return {
      personId: investment.person.id,
      personType: investment.person.personType,
      projectId: investment.project.id,
      quantityTickets: investment.quantityTickets,
      tcaRepresentative: investment.tcaRepresentative || false,
      acceptsCommitment: investment.acceptsCommitment || false,
      termsAndConditions: investment.termsAndConditions,
      status: investment.status,
      acceptedShareholderAgreement: investment.acceptedShareholderAgreement,
      acceptedSyndicateAgreement: investment.acceptedSyndicateAgreement,
      signedShareholderAgreement: investment.signedShareholderAgreement,
      signedSyndicateAgreement: investment.signedSyndicateAgreement,
      dueDiligenceStatus: investment.dueDiligenceStatus,
      essentialAsset: investment.essentialAsset
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/InvestmentFactory.tsx